<template>
  <div class="container">
    <div class="conmonContent">
      <div class="w1600">
        <div class="proTop d-flex j-sb a-start">
          <div class="ptLeft">
            <h3 class="font36 corfff h3">{{ content.name }}</h3>
          </div>
          <!-- 筛选 -->
          <div class="searchblock">
						<search></search>
				</div>
        </div>
        <!-- 主体列表内容 -->
        <div class="psLeftContent">
          <!-- IP产品详情页 -->
          <div class="item w100">
            <div class="text bd10 p3">
              <div class="sTitle d-flex a-center j-sb">
                <h3 class="font20">{{ $t("admin.basicInformation") }}</h3>
              </div>
              <div class="intro d-flex">
                <dl>
                  <dd class="d-flex line-mn">
                    <span class="label font-light">{{ $t("admin.productName") }}</span>
                    <span class="value">{{ content.name }}</span>
                  </dd>
                  <dd class="d-flex line-mn">
                    <span class="label font-light">AE/PE</span>
                    <span class="value">{{ content.engineer }}</span>
                  </dd>
                  <dd class="d-flex line-mn">
                    <span class="label font-light">{{ $t("admin.technology") }}</span>
                    <span class="value">{{ content.technology }}</span>
                  </dd>
                  <dd class="d-flex line-mn">
                    <span class="label font-light">{{ $t("admin.ipType") }}</span>
                    <span class="value">{{ content.ipType }}</span>
                  </dd>
                  
                </dl>
                <dl>
                  <dd class="d-flex line-mn">
                    <span class="label font-light">{{ $t("admin.manager") }}</span>
                    <span class="value">{{ content.manager }}</span>
                  </dd>
                  <dd class="d-flex line-mn">
                    <span class="label font-light">{{ $t("admin.saler") }}</span>
                    <span class="value">{{ content.sales }}</span>
                  </dd>
                  <dd class="d-flex line-mn">
                    <span class="label font-light">{{ $t("admin.ipName") }}</span>
                    <span class="value">{{ content.ipName }}</span>
                  </dd>
                  <dd class="d-flex line-mn">
                    <span class="label font-light">{{ $t("admin.protocol") }}</span>
                    <span class="value">{{ content.protocol }}</span>
                  </dd>
                </dl>
              </div>
            </div>
          </div>
          <!-- 合同里程碑 -->
          <div class="item bd10 p3">
            <div class="sTitle d-flex a-center j-sb">
              <h3 class="font20">{{ $t("admin.contractMilestones") }}</h3>
            </div>
            <div class="table">
              <table class="w100">
                <thead>
                  <tr class="font-light">
                    <th class="td1">{{ $t("admin.serialNumber") }}</th>
                    <th class="td2">{{ $t("admin.typesOf") }}</th>
                    <!-- <th class="t-center">
                      {{ $t("admin.finalMSOfTheContract") }}？
                    </th> -->
                    <th class="td">{{ $t("admin.milestoneName") }}</th>
                    <!-- <th>{{ $t("admin.milestoneDescription") }}</th> -->
                    <th class="td3">{{ $t("admin.dependencyRelationship") }}</th>
                    <th class="td3">{{ $t("admin.expectedCompletionTime") }}</th>
                    <!-- <th>{{ $t("admin.updateCompletionTime") }}</th>
                    <th>{{ $t("admin.expectedCompletionTime") }}</th> -->
                    <th class="td4">{{ $t("admin.actualFinish") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in content.sourceMilestoneList
                      ? content.sourceMilestoneList
                      : []"
                    :key="index"
                  >
                    <td class="font-light td1">{{ item.no }}</td>
                    <td class="font-light td2">{{ item.type }}</td>
                    <!-- <td class="t-center">{{ item.ms }}</td> -->
                    <td class="td">{{ item.name }}</td>
                    <!-- <td>{{ item.description }}</td> -->
                    <td class="td3">{{ item.reliance }}</td>
                    <td class="td3 font-light">{{ item.appointedDate|dataFormate }}</td>
                    <!-- <td class="font-light">{{ item.updatedDate|dataFormate }}</td>
                    <td class="font-light">{{ item.expectedDate|dataFormate }}</td> -->
                    <td class="td4 font-light">{{ item.realityDate|dataFormate }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- 新增里程碑 -->
          <div class="item bd10 p3">
            <div class="sTitle d-flex a-center j-sb">
              <h3 class="font20">{{ $t("admin.addMilestones") }}</h3>
            </div>
            <div class="table">
              <table class="w100">
                <thead>
                  <tr class="font-light">
                    <th class="td1">{{ $t("admin.serialNumber") }}</th>
                    <th class="td2">{{ $t("admin.typesOf") }}</th>
                    <!-- <th class="t-center">
                      {{ $t("admin.finalMSOfTheContract") }}？
                    </th> -->
                    <th class="td">{{ $t("admin.milestoneName") }}</th>
                    <!-- <th>{{ $t("admin.milestoneDescription") }}</th> -->
                    <!-- <th>{{ $t("admin.dependencyRelationship") }}</th> -->
                    <th class="td3"></th>
                    <th class="td3">{{ $t("admin.expectedCompletionTime") }}</th>
                    
                    <!-- <th>{{ $t("admin.updateCompletionTime") }}</th>
                    <th>{{ $t("admin.expectedCompletionTime") }}</th> -->
                    <th class="td4">{{ $t("admin.actualFinish") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in content.newMilestoneList
                      ? content.newMilestoneList
                      : []"
                    :key="index"
                  >
                    <td class="font-light td1">{{ item.no }}</td>
                    <td class="font-light td2">{{ item.type }}</td>
                    <!-- <td class="t-center">{{ item.ms }}</td> -->
                    <td class="td">{{ item.name }}</td>
                    <!-- <td>{{ item.description }}</td> -->
                    <!-- <td>{{ item.reliance }}</td> -->
                    <td class="td3"></td>
                    <td class="font-light td3">{{ item.appointedDate|dataFormate }}</td>
                    
                    <!-- <td class="font-light">{{ item.updatedDate|dataFormate }}</td>
                    <td class="font-light">{{ item.expectedDate|dataFormate }}</td> -->
                    <td class="font-light td4">{{ item.realityDate|dataFormate }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- 交付物 -->
          <div class="item bd10 p3">
            <div class="sTitle d-flex a-center j-sb">
              <h3 class="font20">{{ $t("admin.deliverables") }}</h3>
            </div>
            <div class="table"
            v-loading="loading"
            :element-loading-text="$t('commom.downloadLoadingText')"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
            >
              <table class="w100">
                <thead>
                  <tr class="font-light">
                    <th class="td1">{{ $t("admin.milestoneNumber") }}</th>
                    <th class="td2">{{ $t("admin.deliverables") }}</th>
					          <th class="td">{{ $t("admin.size") }}</th>
                    <th class="td3">{{ $t("admin.deliveryStatus") }}</th>
                    <th class="td3">{{ $t("admin.uploaded") }}</th>
                    
                    <th  class="tcenter td4" v-if="$store.state.permissions?.includes('isIpDown')">
                      <div class="d-flex j-center">
                        {{ $t("admin.downloadBtn") }}
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in content.deliverablesList
                      ? content.deliverablesList
                      : []"
                    :key="index"
                  >
                    <td class="font-light td1">{{ item.milestoneNo }}</td>
                    <td class="td2">{{ item.deliverables }}</td>
					          <td class="td">{{ item.fileSize ? item.fileSize : '/' }}</td>
                    <td class="td3">{{ item.type }}</td>
                    <td class="font-light td3">{{ item.date|dataFormate }}</td>
                    
                    <td class="tcenter td4" v-if="$store.state.permissions?.includes('isIpDown')">
                      <vdownload :id="item.id" path="" api="member/deliverablesDownLog"></vdownload>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "IpProjectDetail",
  components: {},
  data() {
    return {
      // 详细信息
      loading:false,
      content: {},
    };
  },

  created() {
    // 获取详细信息
    this.getContentInfo(this.$route.query.id);
  },

  methods: {
    downloadFile2(id,name,index){
      var that=this;
      if(that.content.deliverablesList[index].dp!=0){return;}
      that.$axios
        .get(`member/deliverablesDownLog?id=${id}`)
        .then((res) => {
          if(!res.data&&res.data==''){return;}
          var durl=res.data.split('admin-api')[1];
          if(that.content.deliverablesList[index].dp==0){
            that.$daxios.get(durl,{
              responseType: 'arraybuffer',
              onDownloadProgress:e=>{
                that.content.deliverablesList[index].dp=Math.floor(e.progress*100);
              },
            }).then(res=>{
              if(res.data&&res.data.size==0){
                that.content.deliverablesList[index].dp=0;
                that.$message({
                  message:"下载失败",
                  type: 'error'
                });
                return;
              };
              const url = window.URL.createObjectURL(new Blob([res]),{ type: 'application/octet-stream' });
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', name);
              document.body.appendChild(link);
              link.click();
              link.remove();
            }).catch(err => {})
          }
        })
        .catch((err) => {});
    },
    downloadFile(id,index){
      var that=this;
      if(that.content.deliverablesList[index].dp!=0){return;}
      that.content.deliverablesList[index].dp=1;
      that.$daxios
        .get(`member/deliverablesDownLog?id=${id}`,{
          responseType: 'blob',
          onDownloadProgress:e=>{
            that.content.deliverablesList[index].dp=Math.floor(e.progress*100);
          },
        })
        .then((res) => {
          if(res.data&&res.data.size==0){
            that.content.deliverablesList[index].dp=0;
            that.$message({
              message:"下载失败",
              type: 'error'
            });
            return;
          };
          const url = window.URL.createObjectURL(new Blob([res.data]),{ type: res.headers['content-type'] });
          const link = document.createElement('a');
          let fileName = res.headers['content-file-name'];
          link.href = url;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .catch((err) => { 
          that.content.deliverablesList[index].dp=0;
        });
    },
    // 获取详细信息
    getContentInfo(id) {
      this.$axios
        .get(`member/ipDetails?id=${id}`)
        .then((res) => {
          res.data.deliverablesList.forEach(i=>{i.dp=0});
          this.content = res.data;
          
        })
        .catch((err) => {});
    },
  },
  filters:{
    dataFormate:function(str1){
     if(!str1||str1==''){
      return ''
     };
     var a=str1.split('/');
     return a[2]+'-'+a[1]+'-'+a[0];
    }
  }
};
</script>

<style lang="less" scoped>

.proTop {
  padding: 0.5rem 0;
  .tags {
    span {
      display: inline-block;
      padding: 0.05rem 0.08rem;
      border-radius: 0.15rem;
      background: #5794f8;
      color: #fff;
      margin-right: 0.1rem;
    }
  }
  .cTopFrom {
    margin: 0;
  }
  @media (max-width: 1200px) {
    display: block;
    .cTopFrom {
      margin: 0.3rem auto 0;
    }
  }
}
.psLeftContent {
  .item {
    &:not(:last-child) {
      margin-bottom: 0.2rem;
    }
  }
  .table {
    overflow-x: auto;
    .d {
      width: 0.15rem;
      height: 0.17rem;
      display: block;
      background: url(@/assets/Icons/downloadGray.png) no-repeat center/100%
        100%;
      &:hover {
        background-image: url(@/assets/Icons/downloadBlue.png);
      }
    }
    td,
    th {
      font-weight: 400;
      white-space: nowrap;

      text-align: left;
      padding: 0.2rem 0;
      padding-right: 0.2rem;
      border-bottom: solid 2px #f2f5fa;
      line-height: 1.3;
      vertical-align: middle;
      &.tcenter{
        text-align: center;
      }
      &:last-child {
        padding-right: 0;
        width: 120px;
      }
      &.td1{
        width: 150px;
      }
      &.td2{
        width: 368px;
      }
      &.td3{
        width: 250px;
      }
      &.td4{
        width: 150px;
      }
      &.td{
        width: 368px;
      }
    }
    tr:hover{
      color: #2657db;
    }
  }
  .intro {
    dl {
      padding-left: 0.2rem;
      border-left: solid 1px #eee;
      padding-right: 5%;
      min-width: 33%;
      .label {
        min-width: 1.5rem;
      }
      dd:not(:last-child) {
        margin-bottom: 0.25rem;
      }
    }
  }
}
@media (max-width: 640px) {
  padding: 0.2rem;
  .topTitle {
    position: relative;
    padding-top: 0.5rem;
    .sTitle a {
      position: absolute;
      right: 0.1rem;
      top: 0.1rem;
    }
  }
  .psLeftContent {
    .intro {
      display: block;
      dl {
        margin-bottom: 0.3rem;
      }
    }
  }
}
</style>
